<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.2469 6.35773L6.98778 11.6168C5.7918 12.8128 3.85273 12.8128 2.65675 11.6168C1.46077 10.4209 1.46077 8.48179 2.65675 7.28581L7.91586 2.0267C8.71318 1.22938 10.0059 1.22938 10.8032 2.0267C11.6005 2.82402 11.6005 4.11673 10.8032 4.91405L5.75034 9.96692C5.35168 10.3656 4.70533 10.3656 4.30667 9.96692C3.90801 9.56826 3.90801 8.92191 4.30667 8.52325L8.74082 4.0891"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
